module.exports = __webpack_public_path__ + "img/body-position-chart-slide3.00c28d09.gif";